var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRental(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    fillRule: "nonzero",
    stroke: "#5E6473",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-label": "property-letter",
    boxSize: 4,
    style: {
      height: 16,
      width: 16,
      color: "rgb(94, 100, 115)",
      marginBottom: "-2px"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99884 21.0037H4.99717C3.89214 21.0037 2.99634 20.1079 2.99634 19.0029V4.99708C2.99634 3.89205 3.89214 2.99625 4.99717 2.99625H17.0022C18.1072 2.99625 19.003 3.89205 19.003 4.99708V7.99833 M12 21.0038L14.6251 20.6796C14.8098 20.6568 14.9816 20.573 15.1133 20.4415L21.4739 14.0809C22.1785 13.3794 22.1811 12.2396 21.4799 11.5348L21.4739 11.5298V11.5298C20.7724 10.8253 19.6327 10.8226 18.9279 11.5238V11.5298L12.6253 17.8324C12.497 17.9598 12.4141 18.1256 12.3892 18.3046L12 21.0038Z M7.99843 17.0021V17.0021C7.16966 17.0021 6.4978 16.3302 6.4978 15.5014V15.5014C6.4978 14.6727 7.16966 14.0008 7.99843 14.0008V14.0008C8.8272 14.0008 9.49905 14.6727 9.49905 15.5014V15.5014C9.49905 16.3302 8.8272 17.0021 7.99843 17.0021Z M6.4978 6.99792H14.5011 M6.4978 10.4994H10.4995"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRental);
export default __webpack_public_path__ + "static/media/rental.655390c8ce4404b724ec9f8826fce788.svg";
export { ForwardRef as ReactComponent };